<template>
  <div>
    <div style="margin-top: 20px; padding: 10px">
      <el-form :inline="true">
        <slot name="search"></slot>
        <el-form-item>
          <el-button type="primary" @click="doSearch">查询</el-button>
          <el-button type="info" @click="reset">重置</el-button>
          <el-button type="success" @click="add">新增</el-button>
          <!-- <el-button type="danger" @click="batchDelete">批量删除</el-button> -->
          <slot name="moreOpt"></slot>
        </el-form-item>
      </el-form>
    </div>

    <el-table
      border
      ref="multipleTable"
      :data="records.records"
      tooltip-effect="dark"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
      <slot name="content"></slot>
      <el-table-column
      label="操作">
      <template slot-scope="scope">
        <el-button type="text" size="small" @click="queryById(scope.row.id)">编辑</el-button>
        <el-button type="text" size="small" @click="deleteById(scope.row.id)">删除</el-button>
        <slot name="operation" :record="scope.row" :rowMeta="scope"></slot><!--插槽里的值往外抛送-->
      </template>
    </el-table-column>
    </el-table>
    <div style="margin-top: 20px">
      <div class="pagenation">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[1,10, 20, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="records.total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TablesComponents",
  props: {
    currentPage: {
      //当前页
      type: Number,
      default: 1,
    },
    records: {
      type: Object,
      default: function () {
        return {}
      }
    },
    search: {
      type: Object,
      default: function () {
        return {}
      }
    },
  },
  data() {
    return {
      multipleSelection: [],
      pageSize:10,
      pageNum:1
    };
  },
  created(){
     this.doSearch();
  },
  methods: {
    doSearch() {
      this.$emit("searchHandler",{pageSize:this.pageSize,pageNum:this.pageNum});
    },
    reset() {
      //重置
      this.$emit("resetHandler");
      this.$emit("searchHandler",{pageSize:this.pageSize,pageNum:this.pageNum});
    },
    add(){
      this.$emit("addHandler");
    },
    queryById(id){
      this.$emit("queryByIdHandler",{"id":id});
    },
    deleteById(id){
      this.$confirmDialog("确定要进行当前操作吗?",()=>{
        this.$emit("deleteByIdHandler",{"id":id});
      })
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row.id);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(rows) {
      let ids = []
      if (rows) {
        rows.forEach((row) => {
          ids.push(row.id);
        })
      }
      this.multipleSelection = ids
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.doSearch();
    },
    handleCurrentChange(pageNum) {
      this.pageNum = pageNum;
      this.doSearch();
    },
    currentPage2() {
      this.doSearch();
    },
    batchDelete(){
      if(this.multipleSelection.length==0){
        this.$errorMsg("请先选择一条记录，再进行当前操作");
        return;
      }
       this.$confirmDialog("确定要进行当前操作吗?",()=>{
        this.$emit("batchDeleteHandler",{"ids":this.multipleSelection});
      })
    }
  },
};
</script>

<style>
.pagenation {
  display: flex;
  justify-content: center;
}
</style>